import About from "pages/About";

export default function AboutPage() {
    return <About/>
    
}